import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { MsalProvider } from '@azure/msal-react'
import { msalInstance } from './config/authConfig'
import { BootstrapGate } from './components/BootstrapGate'
import { SessionGate } from './components/SessionGate'
import { LicenseGate } from './components/license/LicenseGate'
import { FeatureGate } from './components/license/FeatureGate'
import LandingPage from './pages/LandingPage'
import PlatformOverview from './pages/PlatformOverview'
import Dashboard from './pages/Dashboard'
import Onboarding from './pages/Onboarding'
import LicenseError from './pages/LicenseError'
import PermissionsError from './pages/PermissionsError'
import SetupRequired from './pages/SetupRequired'
import SessionExpired from './pages/SessionExpired'
import AdminSettingsPage from './pages/AdminSettingsPage'
import SearchIndexerPage from './pages/SearchIndexer/SearchIndexerPage'
import { RouteChangeTracker } from './observability/routeChangeTracker'
import './App.css'

function App() {
    return (
        <MsalProvider instance={msalInstance}>
            <BrowserRouter>
                <RouteChangeTracker />
                <BootstrapGate>
                    <SessionGate>
                        <Routes>
                            {/* Public pages */}
                            <Route path="/" element={<LandingPage />} />
                            <Route path="/platform" element={<PlatformOverview />} />

                            {/* Error pages */}
                            <Route path="/license-error" element={<LicenseError />} />
                            <Route path="/permissions-error" element={<PermissionsError />} />
                            <Route path="/setup-required" element={<SetupRequired />} />
                            <Route path="/session-expired" element={<SessionExpired />} />

                            {/* Unified onboarding — no LicenseGate, new tenants have no license yet */}
                            <Route
                                path="/onboarding"
                                element={<Onboarding />}
                            />

                            {/* Protected routes */}
                            <Route
                                path="/dashboard"
                                element={
                                    <LicenseGate>
                                        <Dashboard />
                                    </LicenseGate>
                                }
                            />
                            <Route
                                path="/admin/settings"
                                element={
                                    <LicenseGate>
                                        <AdminSettingsPage />
                                    </LicenseGate>
                                }
                            />
                            <Route
                                path="/tools/search-indexer"
                                element={
                                    <LicenseGate>
                                        <FeatureGate featureId="search-indexer">
                                            <SearchIndexerPage />
                                        </FeatureGate>
                                    </LicenseGate>
                                }
                            />
                            <Route path="*" element={<Navigate to="/" replace />} />
                        </Routes>
                    </SessionGate>
                </BootstrapGate>
            </BrowserRouter>
        </MsalProvider>
    )
}

export default App
